import { ACTION_LOGOUT } from "app/modules/login/reducer/actions.type";
import { FETCH_TERM_DEPOSIT_LIST_REQUEST, FETCH_TERM_DEPOSIT_LIST_SUCCESS, FETCH_TERM_DEPOSIT_LIST_FAILURE } from "./actions.type";

import { TermDepositListState, TermDepositListActions } from "./types";

const initialState: TermDepositListState = {
  pending: false,
  listTermDeposit: undefined,
  statusRq: "init",
  errorMsg: undefined,
};

export default (state = initialState, action: TermDepositListActions): TermDepositListState => {
  switch (action.type) {
    case FETCH_TERM_DEPOSIT_LIST_REQUEST:
      return {
        ...state,
        pending: true,
        statusRq: "pending",
        errorMsg: undefined,
      };
    case FETCH_TERM_DEPOSIT_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        listTermDeposit: action.payload,
        statusRq: "ok",
      };
    case FETCH_TERM_DEPOSIT_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        statusRq: "error",
        errorMsg: action.payload,
      };
    case ACTION_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
